import React from 'react';
import classnames from 'classnames';
import { compact } from 'lodash';

import StrapiButton from '../../StrapiLink/StrapiButton';
import { RichTextField } from '../../RichTextField/RichTextField';
import { RichListComponentFragment } from '../../../../graphql.schema';

import * as styles from './StrapiRichList.module.scss';

export const StrapiRichList: React.FC<RichListComponentFragment> = ({ title, description, cta, items }) => {
  return (
    <div className={styles.root}>
      <div className="columns">
        <div className={classnames('content column is-5')}>
          <h2 className="title is-2">{title}</h2>
          <p className={classnames('is-text-2', styles.description)}>{description}</p>
          {cta ? <StrapiButton type="secondary" {...cta} /> : null}
        </div>
        <div className={classnames('column is-5', styles.list)}>
          {compact(items).map((item, idx) => (
            <div key={`rich-list-list-item-${idx}`} className={styles.listItem}>
              <div className={styles.listItemMarker}>{idx + 1}</div>
              <div className={styles.listItemContent}>
                <h3 className="title is-2">{item.title}</h3>
                <RichTextField content={item.content} className={styles.listItemRichText} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
